<template>
    <v-dialog v-model="dialog" width="1200px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Create/Edit Virtual assistant</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-2 px-5">
                <v-row>
                    <v-col cols=2>OpenAI Model</v-col><v-col cols=10><v-select v-model="assistant.model" :items="models" item-value="Option" item-text="Description" dense></v-select></v-col>
                </v-row>
                <v-row>
                    <v-col cols=2>Name</v-col><v-col cols=10><v-text-field v-model="assistant.name" dense></v-text-field></v-col>
                </v-row>
                <v-row>
                    <v-col cols=2>Description</v-col><v-col cols=10><v-text-field v-model="assistant.description" dense></v-text-field></v-col>
                </v-row>
                <v-row>
                    <v-col cols=2>Temperature</v-col><v-col cols=1>{{ temperature / 10 }}</v-col><v-col cols=9><v-slider v-model="temperature" min="0" max="20" dense></v-slider></v-col>
                </v-row>
                <v-row>
                    <v-col cols=2>Instructions</v-col><v-col cols=10><v-textarea v-model="assistant.instructions" rows="4" dense></v-textarea></v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="py-2">
                Note: <br>
                <br>
                <!-- The model is fixed at gpt-3.5-turbo (a cost effective option), and newer 4.x models mainly add image processing that is not needed for this assistant.<br> -->
                The documentation for temperature says: "What sampling temperature to use, between 0 and 2. 
                Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic."
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="saveAssistant(true)">Save & Close</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                editMode: true,

                models: [],

                assistant: {},

                temperature: 0,
            }
        },
        methods: { 
            openDialog(assistant, models) {
                this.editMode = assistant.id !== "";
                this.assistant = assistant;
                this.temperature = this.assistant.temperature * 10;
                this.models = models;
                this.dialog = true;
            },
            closeDialog() {
                this.$emit("updateData", "refresh");
                this.dialog = false;
            },
            saveAssistant() {
                if (this.assistant.name === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Please give the assistant a name",
                        color: "error",
                    });  
                    return
                }
                if (this.assistant.instructions === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Please give the assistant proper instructions",
                        color: "error",
                    });  
                    return
                }
                this.assistant.temperature = this.temperature;
                this.$axios.post("ares/json/ares/syst/openai/saveAssistant.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveAssistant",
                    },
                    saveAssistant: this.assistant,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveAssistant.text,
                            color: res.data.saveAssistant.color,
                        });
                        this.$emit("updateData", "refresh");
                        this.closeDialog();
                    }
                });
            },
        }
    }
</script>
